import { render, staticRenderFns } from "./BOpenDataContent.vue?vue&type=template&id=16e45172&scoped=true"
import script from "./BOpenDataContent.vue?vue&type=script&lang=js"
export * from "./BOpenDataContent.vue?vue&type=script&lang=js"
import style0 from "./BOpenDataContent.vue?vue&type=style&index=0&id=16e45172&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e45172",
  null
  
)

export default component.exports